// extracted by mini-css-extract-plugin
export var button = "Button-module--button--b1113";
export var disabled = "Button-module--disabled--e2d89";
export var green = "Button-module--green--20695";
export var outlined = "Button-module--outlined--e231c";
export var solid = "Button-module--solid--e68ed";